import { render, staticRenderFns } from "./PlainTemplate.vue?vue&type=template&id=1d31d2ed"
import script from "./PlainTemplate.vue?vue&type=script&lang=ts"
export * from "./PlainTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports